<main class="page">
  <a class="back-link" routerLink="/">← Village</a>

  <section class="panel">
    <div class="panel-info">
      <p class="eyebrow">Town Gate</p>
      <h1>Start a Room</h1>
      <p>Create a room, then open the game on your TV/screen and join with phones.</p>
    </div>

    <form class="host-panel" (ngSubmit)="createRoom()">
      <label for="hostName">Room name</label>
      <input id="hostName" name="hostName" [(ngModel)]="hostName" required>
      <button type="submit">Create room</button>
    </form>

    @if (room(); as activeRoom) {
      <div class="room">
        <span class="room-label">Room code</span>
        <strong class="room-code">{{ activeRoom.roomCode }}</strong>

        <div class="room-actions">
          <a class="room-cta primary" [href]="'/godot-screen/' + activeRoom.roomCode">
            🖥 Open Game Screen
          </a>
          <a class="room-cta secondary" [href]="'/godot-phone/' + activeRoom.roomCode">
            📱 Open Phone Controller
          </a>
          <a class="room-cta tertiary" [href]="'/controller/' + activeRoom.roomCode">
            Manual controller
          </a>
        </div>
      </div>
    }
  </section>
</main>
